export default {
    downtimeUrl: "https://cl.kodland.tech",
    successPage: {
      title: "Tebrikler! 🎁",
      subtitle: "Kayıt işlemini tamamlamak için '📆 Şimdi rezervasyon yap' butonuna tıklayın",
      button: "📆 Şimdi rezervasyon yap",
    },
    computer: true,
    stopPage: {
      image: "/welcome/quiz_stop_page.jpg",
      title: "Eğitim platformumuza güvendiğiniz için teşekkür ederiz! Maalesef tabletler veya telefonlar derslerimizi almak için uygun değil. Bir dahaki sefere sizi sınıflarımızda görmekten mutluluk duyarız!",
    },
    quizRotateBySteps: {
      1: {
        question:
          "Baba mısınız, anne misiniz, yoksa çocuk musunuz? 👀",
        answers: [
        {
          answer: "Baba",
          family_member: "Father",
          event_name: "ab_button_click_q1_dad",
          event_source: "google",
        },
        {
          answer: "Anne",
          family_member: "Mother",
          event_name: "ab_button_click_q1_mom",
          event_source: "google",
        },
        {
          answer: "Çocuk",
          family_member: "Child",
          event_name: "ab_button_click_q1_kid",
          event_source: "google",
        },
      ],
      },
      2: {
        question: "Ailenizdeki en yüksek eğitim düzeyi nedir? 🎓",
        answers: [
          {
            answer: "Yüksek lisans veya üzeri",
            family_education: "Master_or_higher",
            event_name: "ab_button_click_q3_master",
            event_source: "google",
          },
          {
            answer: "Lisans",
            family_education: "Bachelor",
            event_name: "ab_button_click_q3_bachelor",
            event_source: "google",
          },
          {
            answer: "Ortaokul",
            family_education: "Secondary",
            event_name: "ab_button_click_q3_secondary",
            event_source: "google",
          },
          {
            answer: "Lise",
            family_education: "Middle_school",
            event_name: "ab_button_click_q3_middle",
            event_source: "google",
          },
        ],
      },
      3: {
        question:
          "Çocuğunuzun cinsiyeti nedir? 👀",
          answers: [
            {
              answer: "Kız",
              child_gender: "Female",
              event_name: "ab_button_click_q4_fem",
              event_source: "google",
            },
            {
              answer: "Erkek",
              child_gender: "Man",
              event_name: "ab_button_click_q4_male",
              event_source: "google",
            },
            {
              answer: "Cevap vermek istemiyorum",
              child_gender: "No_answer",
              event_name: "ab_button_click_q4_none",
              event_source: "google",
            },
          ],
      },
      4: {
        question: "Çocuğunuz hangi tür okulda okuyor? 🍎",
        answers: [
          {
            answer: "Devlet",
            school_type: "Public",
            event_name: "ab_button_click_q5_public",
            event_source: "google",
          },
          {
            answer: "Özel",
            school_type: "Private",
            event_name: "ab_button_click_q5_private",
            event_source: "google",
          },
          {
            answer: "Diğer",
            school_type: "Catholic",
            event_name: "ab_button_click_q5_catholic",
            event_source: "google",
          },
        ],
      },
      5: {
        question: "Çocuğunuz okul dışında hangi etkinliklere katılıyor? ⚽",
        answers: [
          {
            answer: "Yabancı Dil",
            child_classes: "Language",
            event_name: "ab_button_click_q6_language",
            event_source: "google",
          },
          {
            answer: "Sanat",
            child_classes: "Culture",
            event_name: "ab_button_click_q6_culture",
            event_source: "google",
          },
          {
            answer: "Spor",
            child_classes: "Sport",
            event_name: "ab_button_click_q6_sport",
            event_source: "google",
          },
          {
            answer: "Müzik",
            child_classes: "Music",
            event_name: "ab_button_click_q6_music",
            event_source: "google",
          },
          {
            answer: "Diğer",
            child_classes: "Other",
            event_name: "ab_button_click_q6_other",
            event_source: "google",
          },
          {
            answer: "Hiçbiri",
            child_classes: "None",
            event_name: "ab_button_click_q6_none",
            event_source: "google",
          },
        ],
      },
      6: {
        question:
          "Çocuğunuzun çevrimiçi eğitim deneyimi var mı? 🌐",
        answers: [
        {
          answer: "Evet",
          online_education_exp: "Yes",
          event_name: "ab_button_click_q7_yes",
          event_source: "google",
        },
        {
          answer: "Hayır",
          online_education_exp: "No",
          event_name: "ab_button_click_q7_no",
          event_source: "google",
        },
      ],
      },
    },
  };